import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
// import { useSchedulerEditItemPropsContext } from "@progress/kendo-react-scheduler";

export const CustomDialog = (props) => {
  var title = props.children[0].props.valueGetter("title");
  var eventType = props.children[0].props.valueGetter("eventType");
  var paymentType = props.children[0].props.valueGetter("paymentType");
  var bookingType = props.children[0].props.valueGetter("bookingType");
  var bookingLocation = props.children[0].props.valueGetter("bookingLocation");
  var appointmentType = props.children[0].props.valueGetter("appointmenttype");
  var contactMobilePhone = props.children[0].props.valueGetter("contactMobilePhone");

  var className = "";

  switch (eventType) {
    case "Availability":
      title = "Availability";
      className = "availability";
      break;
    case "Unavailable":
      title = "Unavailable";
      className = "unavailable";
      break;
    case "Supervision":
      title = "Supervision";
      className = "supervision";
      break;
    case "NthQLDPHN":
      title = "NthQLDPHN";
      className = "nthqldphn";
      break;

    default: {
      title = `${title ? `Booking: ${title}` : "New Booking"}`;
      if (appointmentType && appointmentType === "1" && bookingLocation === "Remote" && contactMobilePhone) {
        var phoneNumber = contactMobilePhone.slice(0, 4) + " " + contactMobilePhone.slice(4, 7) + " " + contactMobilePhone.slice(7, 10);
        title = `${title} - ${phoneNumber}`;
      }
      className = `${eventType}-${paymentType}`;
    }
  }

  return <Dialog {...props} title={title} id={`rhc-event-${className}`} className="scheduler-dialog" width={800} style={{ zIndex: 1100 }} />;
};
